var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "partnet-point-show"
  }, [_vm.isLoading ? _c('p', [_c('Loading')], 1) : [_c('div', {
    staticClass: "partnet-point-show__header d-flex justify-content-between align-items-center"
  }, [_c('button', {
    staticClass: "s-p-3",
    on: {
      "click": function click($event) {
        return _vm.$router.back();
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "9",
      "height": "16",
      "viewBox": "0 0 9 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.28033 0.46967C8.5466 0.735936 8.5708 1.1526 8.35295 1.44621L8.28033 1.53033L1.811 8L8.28033 14.4697C8.5466 14.7359 8.5708 15.1526 8.35295 15.4462L8.28033 15.5303C8.01406 15.7966 7.5974 15.8208 7.30379 15.6029L7.21967 15.5303L0.21967 8.53033C-0.0465965 8.26406 -0.0708027 7.8474 0.147052 7.55379L0.21967 7.46967L7.21967 0.46967C7.51256 0.176777 7.98744 0.176777 8.28033 0.46967Z",
      "fill": "#666666"
    }
  })])]), _c('div', [_vm._v(_vm._s(_vm.pageTitle))]), _c('div', {
    staticClass: "s-p-3"
  })]), _c('div', {
    staticClass: "s-p-3 min-vh-100"
  }, [_vm.item.name ? _c('div', {
    staticClass: "s-bg-white rounded rounded-2 d-flex align-items-center list__item mb-3"
  }, [_vm.item.image ? _c('div', {
    staticClass: "list__image px-3"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.image,
      "alt": ""
    },
    on: {
      "error": function error($event) {
        $event.target.style.display = 'none';
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "flex-fill px-3"
  }, [_c('div', {
    staticClass: "list__title mb-2"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm.item.available_plans && _vm.item.available_plans.length > 0 ? _vm._l(_vm.sortedAvailablePlans, function (plan) {
    return _c('div', {
      key: plan.id,
      staticClass: "s-text-xs mb-1 list__exchange list__exchange--with-badge"
    }, [_c('span', [_c('span', {
      staticClass: "s-text-primary font-weight-bold"
    }, [_vm._v(_vm._s(plan.exchange.from.value))]), _vm._v(" " + _vm._s(plan.exchange.from.unit) + " → "), _c('span', {
      staticClass: "s-text-primary font-weight-bold"
    }, [_vm._v(_vm._s(plan.exchange.to.value))]), _vm._v(" " + _vm._s(plan.exchange.to.unit) + " ")]), plan.is_sold_out ? _c('span', {
      staticClass: "badge badge-sold-out"
    }, [_vm._v("兌畢")]) : _vm._e()]);
  }) : _vm._e()], 2)]) : _vm._e(), _vm.errorMessage ? _c('div', {
    staticClass: "alert alert-danger mt-3"
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e(), _vm.step === 'init' ? [_c('div', {
    staticClass: "partnet-point-show__info"
  }, [_c('ul', {
    staticClass: "partnet-point-show__info__range"
  }, [_vm.currentPlanPeriods.exchange_period ? _c('li', [_vm._v("兌換活動期間：" + _vm._s(_vm.currentPlanPeriods.exchange_period.start) + " - " + _vm._s(_vm.currentPlanPeriods.exchange_period.end))]) : _vm._e(), _vm.currentPlanPeriods.code_period ? _c('li', [_vm._v("序號兌換效期：" + _vm._s(_vm.currentPlanPeriods.code_period.start) + " - " + _vm._s(_vm.currentPlanPeriods.code_period.end))]) : _vm._e()]), _c('div', {
    staticClass: "divider my-2"
  }), _c('div', {
    staticClass: "partnet-point-show__info__title"
  }, [_vm._v("兌換注意事項")]), _vm.item.event_notes ? _c('div', {
    staticClass: "notes-content",
    domProps: {
      "innerHTML": _vm._s(_vm.item.event_notes)
    }
  }) : _vm._e()])] : _vm._e(), _vm.step === 'confirm' ? [_c('div', {
    staticClass: "divider mt-2"
  }, [_vm._v("兌換序號")]), _vm._l(_vm.sns, function (code, idx) {
    return _c('div', {
      key: idx,
      staticClass: "s-bg-white rounded rounded-2 d-flex align-items-center justify-content-between p-2 mb-1"
    }, [_c('div', {
      staticClass: "serial-number font-weight-bold flex-fill text-center"
    }, [_vm._v(_vm._s(code))]), _vm.isProductExchange ? _c('button', {
      staticClass: "s-btn s-btn-primary s-btn-sm s-text-xs w-auto text-nowrap py-2 px-3",
      on: {
        "click": function click($event) {
          return _vm.openBarcodeModal(code);
        }
      }
    }, [_vm._v("開啟")]) : _c('CopyButton', {
      attrs: {
        "text": code,
        "variant": "logs",
        "success-message": "序號已複製到剪貼簿"
      }
    })], 1);
  })] : _vm._e()], 2), _c('div', {
    staticClass: "footer p-3"
  }, [_vm.step === 'init' ? [_c('div', {
    staticClass: "s-text-xs mb-3"
  }, [_vm._v("可用點數 "), _c('span', {
    staticClass: "s-text-secondary s-text-xl"
  }, [_vm._v(_vm._s(_vm.userPoints.toLocaleString()))])]), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "mr-3 flex-fill"
  }, [_vm.eventIsPublicAccessible && _vm.hasRedeemablePlans ? _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-redeem-solution",
      modifiers: {
        "modal-redeem-solution": true
      }
    }],
    staticClass: "s-btn s-btn-sm px-2 partnet-point-show__redeem-solution"
  }, [_vm._v(_vm._s(_vm.redeemSolution))]) : _c('button', {
    staticClass: "s-btn s-btn-sm px-2 partnet-point-show__redeem-solution",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.redeemSolution))])]), _c('div', [_c('b-form-spinbutton', {
    attrs: {
      "min": "1",
      "max": _vm.maxRedeemableQuantity,
      "disabled": _vm.isInteractionDisabled
    },
    model: {
      value: _vm.quantity,
      callback: function callback($$v) {
        _vm.quantity = $$v;
      },
      expression: "quantity"
    }
  })], 1)]), _c('div', {
    staticClass: "text-center my-2"
  }, [_c('b-form-checkbox', {
    attrs: {
      "size": "sm",
      "disabled": _vm.isInteractionDisabled
    },
    model: {
      value: _vm.agreedTerms,
      callback: function callback($$v) {
        _vm.agreedTerms = $$v;
      },
      expression: "agreedTerms"
    }
  }, [_vm._v(" 我已同意注意事項 ")])], 1), _c('button', {
    staticClass: "s-btn s-btn-primary s-btn-sm px-4",
    attrs: {
      "disabled": _vm.isRedeeming || _vm.isInteractionDisabled
    },
    on: {
      "click": _vm.redeem
    }
  }, [_vm._v(" " + _vm._s(_vm.isRedeeming ? '處理中...' : '確認') + " ")])] : _vm._e(), _vm.step === 'confirm' ? [_c('button', {
    staticClass: "s-btn s-btn-primary s-btn-sm px-4",
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("完成")])] : _vm._e()], 2)], _c('b-modal', {
    attrs: {
      "id": "modal-redeem-solution",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('div', [_vm._v("選擇兌換方案")]), _c('b-button', {
          staticClass: "close",
          attrs: {
            "variant": "link"
          },
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('svg', {
          attrs: {
            "width": "24",
            "height": "24",
            "viewBox": "0 0 24 24",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [_c('path', {
          attrs: {
            "d": "M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z",
            "fill": "#666666"
          }
        })])])];
      }
    }, {
      key: "modal-footer",
      fn: function fn(_ref2) {
        var close = _ref2.close;
        return [_c('div', {
          staticClass: "w-100"
        }, [_c('button', {
          staticClass: "s-btn s-btn-primary s-btn-sm px-4",
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_vm._v("確認")])])];
      }
    }])
  }, [_c('div', {
    staticClass: "px-3 pt-3"
  }, _vm._l(_vm.sortedAvailablePlans, function (plan, idx) {
    return _c('b-form-radio', {
      key: idx,
      staticClass: "mb-3",
      attrs: {
        "value": plan,
        "disabled": plan.is_sold_out
      },
      model: {
        value: _vm.selectedPlan,
        callback: function callback($$v) {
          _vm.selectedPlan = $$v;
        },
        expression: "selectedPlan"
      }
    }, [plan.exchange ? [_vm._v(" " + _vm._s(plan.exchange.from.value) + " " + _vm._s(plan.exchange.from.unit) + " → " + _vm._s(plan.exchange.to.value) + " " + _vm._s(plan.exchange.to.unit) + " "), plan.is_sold_out ? _c('span', {
      staticClass: "badge badge-sold-out ml-2"
    }, [_vm._v("兌畢")]) : _vm._e()] : _vm._e()], 2);
  }), 1)]), _c('BarcodePopup', {
    attrs: {
      "show": _vm.showBarcodeModal,
      "serial-number": _vm.selectedBarcode
    },
    on: {
      "close": _vm.closeBarcodeModal,
      "copied": _vm.onBarcodeCopied
    }
  }), _c('SuccessPopup', {
    attrs: {
      "show": _vm.showSuccessPopup,
      "message": _vm.successMessage
    },
    on: {
      "close": function close($event) {
        _vm.showSuccessPopup = false;
      }
    }
  }), _c('ErrorPopup', {
    attrs: {
      "show": _vm.showWarningPopup,
      "title": _vm.warningMessage,
      "auto-close": 2000
    },
    on: {
      "close": function close($event) {
        _vm.showWarningPopup = false;
      }
    }
  }), _c('ErrorPopup', {
    attrs: {
      "show": _vm.showErrorPopup,
      "title": _vm.errorPopupTitle,
      "description": _vm.errorPopupMessage
    },
    on: {
      "close": function close($event) {
        _vm.showErrorPopup = false;
      }
    }
  }), _c('ConfirmPopup', {
    attrs: {
      "show": _vm.showConfirmPopup,
      "title": _vm.confirmTitle,
      "description": _vm.confirmDescription
    },
    on: {
      "confirm": _vm.handleConfirm,
      "cancel": function cancel($event) {
        _vm.showConfirmPopup = false;
      }
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }